import { render, staticRenderFns } from "./rollbackProcessingTicket.vue?vue&type=template&id=2bb5f7fe&lang=pug"
import script from "./rollbackProcessingTicket.vue?vue&type=script&lang=js"
export * from "./rollbackProcessingTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports